import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'standalone_campaign';
export const route = 'standalone/campaign/[[...campaignParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipstandalonecampaignsuserinfo" */
'../../components/MembershipStandaloneCampaignsUserInfo')));